/**
 * Which files are worth offering an open button for: the ones a browser can
 * render in a tab by itself.
 *
 * Inert formats — images, PDFs, media, text — draw and do nothing, so they are
 * offered on any deployment. HTML and SVG are programs, and are only offered
 * when the hub reports a separate content origin: the page then renders
 * somewhere that holds none of this app's session.
 *
 * The hub decides what is actually served inline, and its list is the one that
 * matters for safety. Keep the two in step — apps/hub/src/preview.ts.
 */
const INERT = new Set([
  'pdf',
  'png', 'jpg', 'jpeg', 'gif', 'webp', 'avif', 'bmp',
  'mp4', 'm4v', 'webm', 'mov',
  'mp3', 'm4a', 'wav', 'ogg', 'flac',
  'txt', 'md', 'log', 'csv', 'json', 'xml', 'yml', 'yaml',
  'ini', 'conf', 'sh', 'py', 'js', 'ts', 'css', 'sql',
])

const EXECUTABLE = new Set(['html', 'htm', 'xhtml', 'svg'])

export function canOpenInBrowser(filename: string, isolatedOrigin: boolean): boolean {
  const extension = filename.split('.').pop()?.toLowerCase()
  if (!extension || extension === filename.toLowerCase()) return false
  return INERT.has(extension) || (isolatedOrigin && EXECUTABLE.has(extension))
}

/**
 * 썸네일을 청해볼 만한 것.
 *
 * 허브가 실제로 만들 수 있는지는 열어봐야 알고(HEIC 는 못 만든다), 못 만들면 화면이
 * 아이콘으로 되돌아간다. 여기서 하는 일은 그림일 리 없는 것에 요청을 보내지 않는 것뿐이다.
 * 목록은 허브의 것과 맞춰둔다 — apps/hub/src/thumbnails.ts.
 */
const PICTURES = new Set([
  'jpg', 'jpeg', 'png', 'webp', 'gif', 'avif', 'tif', 'tiff', 'bmp',
])

export function hasThumbnail(filename: string): boolean {
  const extension = filename.split('.').pop()?.toLowerCase()
  if (!extension || extension === filename.toLowerCase()) return false
  return PICTURES.has(extension)
}
